import { WidgetProps } from '@rjsf/core';
import { UnitSelector } from '../BaseComponents';

const UnitSelectorWithIcon = (props: WidgetProps) => {
    const { options, value, schema, onChange } = props;
    const icon = options.icon as string;

    return (
        <div className="unit-selector-with-icon">
            <img
                className={`icon`}
                id={'icon'}
                src={icon}
                alt="toggle-icon-center"
                onClick={() => null}
            />
            <UnitSelector
                value={value}
                defaultValue={schema.default as string}
                onChange={onChange}
            />
        </div>
    );
};

export default UnitSelectorWithIcon;
